<div [formGroup]="form()" class="flex flex-col gap-4">
    <!-- Seção: Formação -->
    <app-card-content [headerColor]="false" icon="pi pi-graduation-cap" title="Formação" subtitle="Tipo de formação acadêmica">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="field">
                <label for="tipoFormacao" class="font-semibold block mb-2">Tipo de Formação *</label>
                <p-select
                    id="tipoFormacao"
                    formControlName="tipoFormacao"
                    [options]="tipoFormacaoOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o tipo de formação"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    appendTo="body"
                    panelStyleClass="formacao-select-panel"
                    [disabled]="!modoEdicao() || tiposFormacaoCarregando()"
                    [attr.aria-invalid]="campoInvalido('tipoFormacao')"
                    [attr.aria-describedby]="campoInvalido('tipoFormacao') ? 'erro-tipoFormacao' : null"
                />
                @if (campoInvalido('tipoFormacao')) {
                    <small class="erro-campo" id="erro-tipoFormacao">{{ mensagemErroCampo('tipoFormacao') }}</small>
                }
            </div>

            <div class="field">
                <label for="comprovanteGraduacao" class="font-semibold block mb-2">Comprovante de Graduação *</label>
                <p-select
                    id="comprovanteGraduacao"
                    formControlName="comprovanteGraduacao"
                    [options]="comprovanteGraduacaoOptions()"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o comprovante de graduação"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    appendTo="body"
                    panelStyleClass="formacao-select-panel"
                    [disabled]="!modoEdicao() || diplomasCarregando() || !form().get('tipoFormacao')?.value"
                    [attr.aria-invalid]="campoInvalido('comprovanteGraduacao')"
                    [attr.aria-describedby]="campoInvalido('comprovanteGraduacao') ? 'erro-comprovanteGraduacao' : null"
                />
                @if (campoInvalido('comprovanteGraduacao')) {
                    <small class="erro-campo" id="erro-comprovanteGraduacao">{{ mensagemErroCampo('comprovanteGraduacao') }}</small>
                }
            </div>
        </div>
    </app-card-content>

    @if (form().get('comprovanteGraduacao')?.value === 3) {
        <!-- Seção: Prazo para apresentação de diploma -->
        <app-card-content [headerColor]="false" icon="pi pi-clock" title="Prazo para Apresentação do Diploma">
            <div class="prazo-diploma">
                <div class="prazo-diploma__conteudo">
                    <div class="prazo-diploma__bloco">
                        <div class="prazo-diploma__campo">
                            <label for="prazoDiploma">Prazo Diploma</label>
                            <input id="prazoDiploma" type="text" class="p-inputtext p-component prazo-diploma__input readonly-input" [value]="prazoDiploma()" readonly />
                        </div>
                        <div class="prazo-diploma__legenda">
                            <span class="prazo-diploma__legenda-item">
                                <span class="prazo-diploma__legenda-cor prazo-diploma__legenda-cor--pendente"></span>
                                <span>Pendente</span>
                            </span>
                            <span class="prazo-diploma__legenda-item">
                                <span class="prazo-diploma__legenda-cor prazo-diploma__legenda-cor--vencido"></span>
                                <span>Prazo Vencido</span>
                            </span>
                        </div>
                        @if (exibirBotaoProrrogarPrazo()) {
                            <p-button
                                label="Prorrogar Prazo de Apresentação do Diploma"
                                [disabled]="!modoEdicao() || prorrogarPrazoCarregando()"
                                [loading]="prorrogarPrazoCarregando()"
                                styleClass="p-button-secondary p-button-sm prazo-diploma__botao"
                                (onClick)="prorrogarPrazoDiploma.emit()"
                                [appCan]="roleFormacaoProrrogar"
                            ></p-button>
                        }
                    </div>
                    <div class="prazo-diploma__mensagem">Será necessária a apresentação do diploma no prazo de 120 dias, podendo ser prorrogado uma única vez por igual período, contados a partir da data de inscrição do médico.</div>
                </div>
            </div>
        </app-card-content>
    }

    <!-- Seção: Dados da Formação -->
    <app-card-content [headerColor]="false" icon="pi pi-building" title="Dados da Formação" subtitle="Informações da instituição e formação">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div class="field">
                <label for="nomeEscola" class="font-semibold block mb-2">Nome da Escola *</label>
                <div class="grid grid-cols-[1fr_auto] gap-2">
                    <input
                        pInputText
                        id="nomeEscola"
                        formControlName="nomeEscola"
                        maxlength="70"
                        placeholder="Nome da escola"
                        [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                        [readonly]="true"
                        [attr.aria-invalid]="campoInvalido('nomeEscola')"
                        [attr.aria-describedby]="campoInvalido('nomeEscola') ? 'erro-nomeEscola' : null"
                    />
                    <p-button icon="pi pi-search" [disabled]="!modoEdicao()" (onClick)="pesquisarEscola.emit()"></p-button>
                </div>
                @if (campoInvalido('nomeEscola')) {
                    <small class="erro-campo" id="erro-nomeEscola">{{ mensagemErroCampo('nomeEscola') }}</small>
                }
            </div>

            <div class="field">
                <label for="nomeAnteriorEscola" class="font-semibold block mb-2">Nome Anterior da Escola</label>
                <input
                    pInputText
                    id="nomeAnteriorEscola"
                    formControlName="nomeAnteriorEscola"
                    maxlength="100"
                    placeholder="Nome anterior da escola"
                    [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('nomeAnteriorEscola')"
                    [attr.aria-describedby]="campoInvalido('nomeAnteriorEscola') ? 'erro-nomeAnteriorEscola' : null"
                />
                @if (campoInvalido('nomeAnteriorEscola')) {
                    <small class="erro-campo" id="erro-nomeAnteriorEscola">{{ mensagemErroCampo('nomeAnteriorEscola') }}</small>
                }
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4 mb-6">
            <div class="field">
                <label for="dataCriacaoEscola" class="font-semibold block mb-2">Dt. Criação Escola</label>
                <p-inputmask
                    id="dataCriacaoEscola"
                    formControlName="dataCriacaoEscola"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [disabled]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('dataCriacaoEscola')"
                    [attr.aria-describedby]="campoInvalido('dataCriacaoEscola') ? 'erro-dataCriacaoEscola' : null"
                />
                @if (campoInvalido('dataCriacaoEscola')) {
                    <small class="erro-campo" id="erro-dataCriacaoEscola">{{ mensagemErroCampo('dataCriacaoEscola') }}</small>
                }
            </div>

            <div class="field">
                <label for="dataCriacaoCurso" class="font-semibold block mb-2">Dt. Criação Curso</label>
                <p-inputmask
                    id="dataCriacaoCurso"
                    formControlName="dataCriacaoCurso"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [disabled]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('dataCriacaoCurso')"
                    [attr.aria-describedby]="campoInvalido('dataCriacaoCurso') ? 'erro-dataCriacaoCurso' : null"
                />
                @if (campoInvalido('dataCriacaoCurso')) {
                    <small class="erro-campo" id="erro-dataCriacaoCurso">{{ mensagemErroCampo('dataCriacaoCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="dataFormatura" class="font-semibold block mb-2">Dt. Formação *</label>
                <p-inputmask
                    id="dataFormatura"
                    formControlName="dataFormatura"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [disabled]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('dataFormatura')"
                    [attr.aria-describedby]="campoInvalido('dataFormatura') ? 'erro-dataFormatura' : null"
                />
                @if (campoInvalido('dataFormatura')) {
                    <small class="erro-campo" id="erro-dataFormatura">{{ mensagemErroCampo('dataFormatura') }}</small>
                }
            </div>

            <div class="field">
                <label for="dataInicioCurso" class="font-semibold block mb-2">Dt. Início Curso</label>
                <p-inputmask
                    id="dataInicioCurso"
                    formControlName="dataInicioCurso"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [disabled]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('dataInicioCurso')"
                    [attr.aria-describedby]="campoInvalido('dataInicioCurso') ? 'erro-dataInicioCurso' : null"
                />
                @if (campoInvalido('dataInicioCurso')) {
                    <small class="erro-campo" id="erro-dataInicioCurso">{{ mensagemErroCampo('dataInicioCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="dataConclusaoCurso" class="font-semibold block mb-2">Dt. Fim Curso</label>
                <p-inputmask
                    id="dataConclusaoCurso"
                    formControlName="dataConclusaoCurso"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [disabled]="!modoEdicao()"
                    [attr.aria-invalid]="campoInvalido('dataConclusaoCurso')"
                    [attr.aria-describedby]="campoInvalido('dataConclusaoCurso') ? 'erro-dataConclusaoCurso' : null"
                />
                @if (campoInvalido('dataConclusaoCurso')) {
                    <small class="erro-campo" id="erro-dataConclusaoCurso">{{ mensagemErroCampo('dataConclusaoCurso') }}</small>
                }
            </div>

            <div class="field">
                <label for="expedirDiploma" class="font-semibold block mb-2">Exp. Dip./Reval.</label>
                <p-inputmask id="expedirDiploma" formControlName="expedirDiploma" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [disabled]="!modoEdicao()" />
            </div>

            <div class="field">
                <label for="numeroProcessoDiploma" class="font-semibold block mb-2">Nº Proc. Diploma</label>
                <input pInputText id="numeroProcessoDiploma" formControlName="numeroProcessoDiploma" maxlength="20" placeholder="Número do processo" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
            <div class="field">
                <label for="cargaHoraria" class="font-semibold block mb-2">Carga Horária</label>
                <input
                    pInputText
                    id="cargaHoraria"
                    formControlName="cargaHoraria"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    maxlength="6"
                    placeholder="Carga horária"
                    [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                    (input)="onCargaHorariaInput($event)"
                    [attr.aria-invalid]="campoInvalido('cargaHoraria')"
                    [attr.aria-describedby]="campoInvalido('cargaHoraria') ? 'erro-cargaHoraria' : null"
                />
                @if (campoInvalido('cargaHoraria')) {
                    <small class="erro-campo" id="erro-cargaHoraria">{{ mensagemErroCampo('cargaHoraria') }}</small>
                }
            </div>

            <div class="field">
                <label for="tese" class="font-semibold block mb-2">Tese</label>
                <input pInputText id="tese" formControlName="tese" maxlength="300" placeholder="Tese" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>

            <div class="field">
                <label for="livroRegistroDiploma" class="font-semibold block mb-2">Livro Reg. Diploma</label>
                <input pInputText id="livroRegistroDiploma" formControlName="livroRegistroDiploma" maxlength="20" placeholder="Livro de registro" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>

            <div class="field">
                <label for="numeroFolhaRegistro" class="font-semibold block mb-2">Nº Folha Registro</label>
                <input pInputText id="numeroFolhaRegistro" formControlName="numeroFolhaRegistro" maxlength="20" placeholder="Número da folha" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>

            <div class="field">
                <label for="numeroRegistroMEC" class="font-semibold block mb-2">Nº Reg. MEC</label>
                <input pInputText id="numeroRegistroMEC" formControlName="numeroRegistroMEC" maxlength="25" placeholder="Registro MEC" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>

            <div class="field">
                <label for="dataRegistroMEC" class="font-semibold block mb-2">Dt. de Reg. MEC</label>
                <p-inputmask id="dataRegistroMEC" formControlName="dataRegistroMEC" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [disabled]="!modoEdicao()" />
            </div>
        </div>

        <!-- Autoriza Divulgação -->
        <div class="grid grid-cols-1 gap-4">
            <div class="field">
                <label for="autorizaDivulgacao" class="font-semibold block mb-2">Autoriza Divulgação</label>
                <app-switch-sim-nao inputId="autorizaDivulgacao" formControlName="autorizaDivulgacao" [desabilitado]="!modoEdicao()" />
            </div>
            <div class="field">
                <label for="apresentouDiploma" class="font-semibold block mb-2">Apresentou Diploma</label>
                <app-switch-sim-nao inputId="apresentouDiploma" formControlName="apresentouDiploma" [desabilitado]="!modoEdicao() || form().get('comprovanteGraduacao')?.value === 3" />
            </div>
        </div>
    </app-card-content>

    @if (form().get('tipoFormacao')?.value === 10) {
        <app-card-content [headerColor]="false" icon="pi pi-building-columns" title="IES / Curso" subtitle="Campos obrigatórios para dispensa de apresentação de diploma">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div class="field">
                    <label for="idPrestadorIes" class="font-semibold block mb-2">ID Prestador IES</label>
                    <input pInputText id="idPrestadorIes" formControlName="idPrestadorIes" placeholder="ID" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field">
                    <label for="ufPrestadorIes" class="font-semibold block mb-2">UF Prestador IES</label>
                    <input pInputText id="ufPrestadorIes" formControlName="ufPrestadorIes" maxlength="2" placeholder="UF" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field md:col-span-2">
                    <label for="nomeCurso" class="font-semibold block mb-2">Nome do Curso</label>
                    <input pInputText id="nomeCurso" formControlName="nomeCurso" maxlength="300" placeholder="Nome do curso" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
            </div>
        </app-card-content>
    }

    @if (form().get('idTipoDiploma')?.value === 2) {
        <app-card-content [headerColor]="false" icon="pi pi-file-check" title="E-Diploma" subtitle="Dados de validação e arquivos do diploma eletrônico">
            <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <div class="field">
                    <label for="codigoValidacaoDiploma" class="font-semibold block mb-2">Código de Validação</label>
                    <input pInputText id="codigoValidacaoDiploma" formControlName="codigoValidacaoDiploma" maxlength="200" placeholder="Código" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field md:col-span-2">
                    <label for="urlValidacaoDiploma" class="font-semibold block mb-2">URL de Validação</label>
                    <input pInputText id="urlValidacaoDiploma" formControlName="urlValidacaoDiploma" maxlength="100" placeholder="https://..." [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field">
                    <label for="idLocalDiploma" class="font-semibold block mb-2">ID Local</label>
                    <input pInputText id="idLocalDiploma" formControlName="idLocalDiploma" placeholder="Local" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field">
                    <label for="nomeRepresentacaoGraficaDiploma" class="font-semibold block mb-2">Representação Gráfica</label>
                    <input
                        pInputText
                        id="nomeRepresentacaoGraficaDiploma"
                        formControlName="nomeRepresentacaoGraficaDiploma"
                        maxlength="100"
                        placeholder="Arquivo PDF"
                        [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                        [readonly]="!modoEdicao()"
                    />
                </div>
                <div class="field">
                    <label for="nomeXmlDiploma" class="font-semibold block mb-2">XML</label>
                    <input pInputText id="nomeXmlDiploma" formControlName="nomeXmlDiploma" maxlength="100" placeholder="Arquivo XML" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
                <div class="field">
                    <label for="nomeRelatorioDiploma" class="font-semibold block mb-2">Relatório de Confirmação</label>
                    <input pInputText id="nomeRelatorioDiploma" formControlName="nomeRelatorioDiploma" maxlength="100" placeholder="Arquivo relatório" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
            </div>
        </app-card-content>
    }

    <!-- Seção: Faculdade Estrangeira -->
    @if (form().get('tipoFormacao')?.value === 7 || form().get('tipoFormacao')?.value === 10) {
        <app-card-content [headerColor]="false" icon="pi pi-globe" title="Faculdade Estrangeira" subtitle="Preenchimento obrigatório para FME">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div class="field md:col-span-1">
                    <label for="paisOrigemFaculdade" class="font-semibold block mb-2">País de Origem da Faculdade</label>
                    <p-select
                        id="paisOrigemFaculdade"
                        formControlName="paisOrigemFaculdade"
                        [options]="paisesOptions()"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione"
                        [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                        appendTo="body"
                        panelStyleClass="formacao-select-panel"
                        [disabled]="!modoEdicao() || paisesCarregando()"
                    />
                </div>

                <div class="field md:col-span-2">
                    <label for="nomeFaculdadeEstrangeira" class="font-semibold block mb-2">Nome da Faculdade Estrangeira</label>
                    <input pInputText id="nomeFaculdadeEstrangeira" formControlName="nomeFaculdadeEstrangeira" maxlength="100" placeholder="Nome da faculdade" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                <div class="field md:col-start-2">
                    <label for="urlDocumentosComprobatorios" class="font-semibold block mb-2">URL dos Documentos Comprobatórios</label>
                    <div class="grid grid-cols-[1fr_auto] gap-2">
                        <input
                            pInputText
                            id="urlDocumentosComprobatorios"
                            formControlName="urlDocumentosComprobatorios"
                            maxlength="500"
                            placeholder="URL dos documentos"
                            [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [readonly]="!modoEdicao()"
                        />
                        <p-button
                            type="button"
                            icon="pi pi-external-link"
                            styleClass="p-button-secondary p-button-sm faculdade-estrangeira__botao-url"
                            [disabled]="!form().get('urlDocumentosComprobatorios')?.value"
                            (onClick)="abrirDocumentoComprobatorio()"
                        ></p-button>
                    </div>
                </div>
            </div>
        </app-card-content>
    }
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as anexo) {
        <app-visualizador-pdf [src]="anexo" [fileName]="nomeArquivoAnexo" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="text-center text-color-secondary italic p-4">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
